export default function scrollToTop(OFFSET = 0) {
  document.documentElement.scrollTo({ top: OFFSET, behavior: 'smooth' });
}
